var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('partner-notice-form',{attrs:{"initial-notice-form":_vm.initialNoticeForm},on:{"upsert-notice":_vm.registerNotice,"cancel":_vm.onNegativeClick}})}
var staticRenderFns = []

export { render, staticRenderFns }